import React from 'react'
import { ArticleCards } from './ArticleCard'
import { AudioCards } from './AudioCard'
import { VideoCards } from './VideoCard'
import { ExerciseCards } from './ExerciseCard'
import { QuizCards } from './QuizCard'
import { WorkshopCards } from './WorkshopCard'
import { ScriptCards } from './ScriptCard'
import { ChecklistCards } from './ChecklistCard'
import { useResources } from './ResourcesProvider'
import { useTranslation } from '../../hooks/useTranslation'

const NoFavoritesMessage = () => {
  const { t } = useTranslation('FavoritesCards')

  return (
    <div className="col-span-1 mt-5 text-center md:col-span-2 lg:col-span-3">
      <img
        src="https://www-yns-com.s3.us-east-2.amazonaws.com/images/no_favorites.png"
        alt={t('no_bookmarks')}
        className="mx-auto mb-6"
      />
      <h2 className="mb-4">{t('no_bookmarks')}</h2>
      <p>{t('explore_other_sections')}</p>
    </div>
  )
}

const FavoritesCards = () => {
  const { hasFavorites } = useResources()
  return (
    <>
      {hasFavorites() ? (
        <>
          <ArticleCards />
          <AudioCards />
          <VideoCards />
          <ExerciseCards />
          <QuizCards />
          <WorkshopCards />
          <ChecklistCards />
          <ScriptCards />
        </>
      ) : (
        <NoFavoritesMessage />
      )}
    </>
  )
}
export default FavoritesCards
